import { BrandedButtonService, BrandedButtonMode } from '@hh.ru/magritte-ui-branded-button/types';
import { IconWrapperComponentSize24 } from '@hh.ru/magritte-ui-icon';
import { EllipsisHorizontalOutlinedSize24 } from '@hh.ru/magritte-ui-icon/variants/icon';
import {
    AppleBrandAltSize24,
    AppleGrayscaleSize24,
    AppleBrandSize24,
    AppleSolidSize24,
    VkBrandAltSize24,
    VkGrayscaleSize24,
    VkBrandSize24,
    VkSolidSize24,
    GoogleBrandSize24,
    GoogleGrayscaleSize24,
    GoogleSolidSize24,
    MailBrandAltSize24,
    MailBrandSize24,
    MailGrayscaleSize24,
    MailSolidSize24,
    OkBrandAltSize24,
    OkBrandSize24,
    OkGrayscaleSize24,
    OkSolidSize24,
    EsiaBrandAltSize24,
    EsiaBrandSize24,
    EsiaGrayscaleSize24,
    EsiaSolidSize24,
    TinkoffIdBrandSize24,
    TinkoffIdGrayscaleSize24,
    TinkoffIdSolidSize24,
    YandexBrandAltSize24,
    YandexBrandSize24,
    YandexSolidSize24,
    YandexGrayscaleSize24,
    TinkoffBrandAltSize24,
    TinkoffGrayscaleSize24,
    TinkoffBrandSize24,
    TinkoffSolidSize24,
} from '@hh.ru/magritte-ui-icon/variants/service';

type Map = Partial<
    Record<
        BrandedButtonService | 'more',
        Record<BrandedButtonMode, Record<'default' | 'disabled', IconWrapperComponentSize24>>
    >
>;

export const SERVICE_ICON_MAP: Map = {
    apple: {
        primary: {
            default: AppleBrandAltSize24,
            disabled: AppleGrayscaleSize24,
        },
        secondary: {
            default: AppleBrandSize24,
            disabled: AppleGrayscaleSize24,
        },
        tertiary: {
            default: AppleSolidSize24,
            disabled: AppleSolidSize24,
        },
    },
    vk: {
        primary: {
            default: VkBrandAltSize24,
            disabled: VkGrayscaleSize24,
        },
        secondary: {
            default: VkBrandSize24,
            disabled: VkGrayscaleSize24,
        },
        tertiary: {
            default: VkSolidSize24,
            disabled: VkSolidSize24,
        },
    },
    google: {
        primary: {
            default: GoogleBrandSize24,
            disabled: GoogleGrayscaleSize24,
        },
        secondary: {
            default: GoogleBrandSize24,
            disabled: GoogleGrayscaleSize24,
        },
        tertiary: {
            default: GoogleSolidSize24,
            disabled: GoogleSolidSize24,
        },
    },
    mail: {
        primary: {
            default: MailBrandAltSize24,
            disabled: MailGrayscaleSize24,
        },
        secondary: {
            default: MailBrandSize24,
            disabled: MailGrayscaleSize24,
        },
        tertiary: {
            default: MailSolidSize24,
            disabled: MailSolidSize24,
        },
    },
    ok: {
        primary: {
            default: OkBrandAltSize24,
            disabled: OkGrayscaleSize24,
        },
        secondary: {
            default: OkBrandSize24,
            disabled: OkGrayscaleSize24,
        },
        tertiary: {
            default: OkSolidSize24,
            disabled: OkSolidSize24,
        },
    },
    esia: {
        primary: {
            default: EsiaBrandAltSize24,
            disabled: EsiaGrayscaleSize24,
        },
        secondary: {
            default: EsiaBrandSize24,
            disabled: EsiaGrayscaleSize24,
        },
        tertiary: {
            default: EsiaSolidSize24,
            disabled: EsiaSolidSize24,
        },
    },
    't-bank': {
        primary: {
            default: TinkoffIdBrandSize24,
            disabled: TinkoffIdGrayscaleSize24,
        },
        secondary: {
            default: TinkoffIdBrandSize24,
            disabled: TinkoffIdGrayscaleSize24,
        },
        tertiary: {
            default: TinkoffIdSolidSize24,
            disabled: TinkoffIdSolidSize24,
        },
    },
    yandex: {
        primary: {
            default: YandexBrandAltSize24,
            disabled: YandexGrayscaleSize24,
        },
        secondary: {
            default: YandexBrandSize24,
            disabled: YandexGrayscaleSize24,
        },
        tertiary: {
            default: YandexSolidSize24,
            disabled: YandexSolidSize24,
        },
    },
};

export const SERVICE_ONLY_ICON_MAP: Map = {
    ...SERVICE_ICON_MAP,
    't-bank': {
        primary: {
            default: TinkoffBrandAltSize24,
            disabled: TinkoffGrayscaleSize24,
        },
        secondary: {
            default: TinkoffBrandSize24,
            disabled: TinkoffGrayscaleSize24,
        },
        tertiary: {
            default: TinkoffSolidSize24,
            disabled: TinkoffSolidSize24,
        },
    },
    more: {
        primary: {
            default: EllipsisHorizontalOutlinedSize24,
            disabled: EllipsisHorizontalOutlinedSize24,
        },
        secondary: {
            default: EllipsisHorizontalOutlinedSize24,
            disabled: EllipsisHorizontalOutlinedSize24,
        },
        tertiary: {
            default: EllipsisHorizontalOutlinedSize24,
            disabled: EllipsisHorizontalOutlinedSize24,
        },
    },
};
